// Checks if the window object is available and thereby if the code is running in the browser.
export const isBrowser = typeof window !== `undefined`

// Checks if the window object is not available and thereby if the code is running in the server.
export const isSSR = typeof window === `undefined`
